const cleanUrl = () => {
	setTimeout(() => {
		// history.pushState(null, '', `${location.href.replace(window.location.search, '')}`);
	}, 1000);
};

export default cleanUrl;
